import api from './api';

// Serviço para gerenciar tipos de produto
export const tipoProdutoService = {
  // Listar tipos de produto com paginação e filtros
  async list(params = {}) {
    try {
      const response = await api.get('/tipo-produto', { params });
      return {
        tiposProduto: response.data.data,
        pagination: response.data.pagination
      };
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar tipos de produto');
    }
  },

  // Buscar tipo de produto por ID
  async getById(id) {
    try {
      const response = await api.get(`/tipo-produto/${id}`);
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar tipo de produto');
    }
  },

  // Criar tipo de produto
  async create(tipoProdutoData) {
    try {
      const response = await api.post('/tipo-produto', tipoProdutoData);
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao criar tipo de produto');
    }
  },

  // Atualizar tipo de produto
  async update(id, tipoProdutoData) {
    try {
      const response = await api.put(`/tipo-produto/${id}`, tipoProdutoData);
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao atualizar tipo de produto');
    }
  },

  // Deletar tipo de produto
  async delete(id) {
    try {
      const response = await api.delete(`/tipo-produto/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao excluir tipo de produto');
    }
  },

  // Buscar todos os tipos de produto ativos para selects
  async getAll() {
    try {
      const response = await api.get('/tipo-produto', { 
        params: { status: 'Ativo', limit: 1000 }
      });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao buscar tipos de produto'
      };
    }
  },
};

// Funções de compatibilidade com o código existente
export const fetchTipoProdutos = async (params = {}) => {
  const result = await tipoProdutoService.list(params);
  return result; // Retorna o array de tipos de produto
};

export const fetchTipoProdutoById = async (id) => {
  return await tipoProdutoService.getById(id);
};

export const createTipoProduto = async (data) => {
  return await tipoProdutoService.create(data);
};

export const updateTipoProduto = async (id, data) => {
  return await tipoProdutoService.update(id, data);
};

export const deleteTipoProduto = async (id) => {
  return await tipoProdutoService.delete(id);
};
